import axios from "axios";

/**
 * API base URL.
 *
 * Defaults to production, so an ordinary `npm run build` is unchanged. To point
 * a local dev server at a local backend, create `app/.env.local` (gitignored,
 * never committed) with:
 *
 *   REACT_APP_API_URL=http://localhost:8001/api
 *
 * CRA only reads .env files at startup — restart `npm start` after changing it.
 */
const PRODUCTION_API_URL = "https://apizeus.slapie.com.br/api";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || PRODUCTION_API_URL,
});

// Loud on purpose: hitting a non-production API is worth noticing in the console.
if (
  process.env.NODE_ENV === "development" &&
  instance.defaults.baseURL !== PRODUCTION_API_URL
) {
  // eslint-disable-next-line no-console
  console.info(`[api] baseURL → ${instance.defaults.baseURL}`);
}

export default instance;
